import Lottie from 'react-lottie';
import React from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import {selectSharingDuration, selectSharingOn, selectTimer} from './liveLocationSlice';
import clockAnimation from './clock-animation.json';
import {fontSize, tabletWidth} from '../../mixins';

const defaultAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: clockAnimation,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};


const StyledTimeBlock = styled.div`
  max-width: 250px;
  display: flex;
  justify-content: start;
  align-items: center;;
  margin-right: auto;
  
  p {
     ${fontSize(12)};
     line-height: 16px;
     color: #000000;
     letter-spacing: -0.28px;
     margin: 5px 0;
     position: relative;
     padding-left: 6px;
     flex-grow: 1;
     
     @media screen and (min-width: ${tabletWidth}) {
        line-height: 22px;
        text-align: left;
     }
  }
  
  span {
    color: #00BFA5;
  }
`

const StyledNotAvailable = styled.p`
   font-size: 14px;
   line-height: 22px;
   letter-spacing: -0.28px;
   color: #F3364E;
   position: relative;
   padding-left: 28px;
   margin: 0;


    &::before {
       content: "";
       width: 20px;
       height: 20px;
       background-color: #F3364E;
       opacity: 0.2;
       border-radius: 50%;
       position: absolute;
       left: 0;
      }
`


const timeToDisplay = (hours, mins, sharingDuration) => {

    if (hours <= 0 && 0 < mins < 1) {
        return (
            <p>Available for <span>less than a minute</span></p>
        );
    }

    if (sharingDuration >= 3600) {

        if (hours <= 0) {
            return (
                <p>Available for <span>{mins}</span> minutes</p>
            );
        }
        return (
            <p>Available for <span>{hours}</span> hours and <span>{mins}</span> minutes</p>
        );
    }

    if (mins === 1) {
        return (
            <p>Available for <span>{mins}</span> minute</p>
        );
    }

    return (
        <p>Available for <span>{mins}</span> minutes</p>
    );
};


const Timer = () => {
    const isSharingOn = useSelector((selectSharingOn));
    const timer = useSelector(selectTimer);
    const sharingDuration = useSelector(selectSharingDuration);


    return (
        <>
            {isSharingOn ? <StyledTimeBlock>
                <Lottie
                    options={defaultAnimationOptions}
                    height={25}
                    width={25}
                />
                {timeToDisplay(timer.hours, timer.mins, sharingDuration)}
            </StyledTimeBlock> : <StyledNotAvailable>Not available</StyledNotAvailable>}

        </>
    )
};


export default Timer;